import Loading from '../../../../Dashboards/Common/Loading';
import { ChildrenMortality } from './ChildrenMortality';
import { DeathsOfWomenOfChildbearingAge } from './DeathsOfWomenOfChildbearingAge';
import { TenagerMothers } from './TenagerMothers';
import { DeathMothersAge } from './DeathMothersAge';
import { useMortalityMobidityChartsDataContext } from './hooks/useMortalityMobidityChartsDataContext';
import { LiveBirthsMothersAge } from './LiveBirthsMothersAge';
import { InfantAndFetalMortality } from './InfantAndFetalMortality';
import { PrematureNewborns } from './PrematureNewborns';
import { EarlyNeonatalMortality } from './EarlyNeonatalMortality';
import { LateNeonatalMortality } from './LateNeonatalMortality';
import { PostNeonatalMortality } from './PostNeonatalMortality';
import { MothersDeaths } from './MothersDeaths';

export const Charts = () => {
    const { isLoading } = useMortalityMobidityChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <LiveBirthsMothersAge />
                <DeathMothersAge />
            </div>
            <div className="chats-indicators-side-by-side-dashboards">
                <ChildrenMortality />
                <InfantAndFetalMortality />
                <PrematureNewborns />

                <EarlyNeonatalMortality />
                <LateNeonatalMortality />
                <PostNeonatalMortality />

                <MothersDeaths />
                <DeathsOfWomenOfChildbearingAge />
                <TenagerMothers />
            </div>
        </>
    );
};
